import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import ApplicationPage from './pages/ApplicationPage';
import { AppProvider } from './context/AppContext'; // useAppContext здесь не нужен
import NotificationSystem from './components/NotificationSystem';
// import logoImage from './assets/images/logo.png'; // Не используется здесь после удаления AppHeader
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import UserApplicationsPage from './pages/UserApplicationsPage';
import HomePage from './pages/HomePageNew';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'; // Импортируем PrivacyPolicyPage
import MainLayout from './components/MainLayout'; // Импортируем MainLayout
import PDResultPage from './pages/PDResultPage'; // Импортируем PDResultPage
import SchemeDetailPage from './pages/SchemeDetailPage'; // Импортируем SchemeDetailPage
import SingleLineSchemesPage from './pages/SingleLineSchemesPage';
import SpecificationMatchingPage from './pages/SpecificationMatchingPage';
import ProductPainSeoPage, { productPainPages } from './pages/ProductPainSeoPage';
import { trackPageView } from './utils/metrika';

// MainLayoutWithProtection больше не нужен, ProtectedRoute будет применен к каждому маршруту индивидуально

const Footer = () => (
  <footer className="bg-gray-200 border-t border-gray-300 py-4"> {/* Стиль футера для светлой темы */}
    <div className="container mx-auto px-4 text-center text-gray-600">
      <p>&copy; {new Date().getFullYear()} Get-Goods.ai</p>
      <p className="mt-2">
        <Link to="/privacy-policy" className="text-blue-600 hover:underline">Политика конфиденциальности</Link>
      </p>
    </div>
  </footer>
);

const NotFoundPage = () => (
  <div className="container mx-auto px-4 py-8 text-center">
    <div className="bg-red-100 border border-red-300 text-red-700 px-6 py-4 rounded-lg shadow-md"> {/* Стиль для светлой темы */}
      <h2 className="text-3xl font-bold mb-3 text-red-800">404 - Страница не найдена</h2>
      <p className="text-lg mb-5 text-red-700">Извините, страница, которую вы ищете, не существует или была перемещена.</p>
      <Link
        to="/"
        className="mt-4 inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-150 ease-in-out font-semibold"
      >
        Вернуться на главную
      </Link>
    </div>
  </div>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const MetrikaRouteTracker = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    trackPageView(`${window.location.origin}${location.pathname}${location.search}${location.hash}`);
  }, [location]);

  return null;
};

function App() {
  return (
    <Router>
      <AppProvider>
        <ScrollToTop />
        <MetrikaRouteTracker />
        {/* Применяем инлайновый стиль для фона, чтобы гарантировать его применение */}
        <div
          className="min-h-screen bg-white text-gray-900 flex flex-col"
        >
          <div className="flex-grow"> {/* Этот div растягивается, чтобы футер был внизу */}
            <Routes>
              {/* Маршруты без MainLayout (например, главная страница и страница входа) */}
              <Route path="/" element={<HomePage />} />
              <Route path="/podbor-elektrotehniki-po-specifikacii" element={<SpecificationMatchingPage />} />
              <Route path="/raspoznavanie-odnolineynyh-shem" element={<SingleLineSchemesPage />} />
              {productPainPages.map((page) => (
                <Route
                  key={page.path}
                  path={page.path}
                  element={<ProductPainSeoPage page={page} />}
                />
              ))}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} /> {/* Новый маршрут для политики конфиденциальности */}

              {/* Маршруты, использующие MainLayout (содержат SideNav) */}
              <Route element={<MainLayout />}> {/* Используем MainLayout напрямую */}
                <Route
                  path="/applications/:appId"
                  element={
                    <ProtectedRoute>
                      <ApplicationPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/applications/:appId/pd-result"
                  element={
                    <ProtectedRoute>
                      <PDResultPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/applications/:appId/schemes/:schemeIndex"
                  element={
                    <ProtectedRoute>
                      <SchemeDetailPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/my-applications"
                  element={
                    <ProtectedRoute>
                      <UserApplicationsPage />
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* 404 page */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </div>
          
          <Footer />
          <NotificationSystem />
        </div>
      </AppProvider>
    </Router>
  );
}

export default App;
